import React, { Component } from 'react';
import { connect } from 'react-redux';
import animateScrollTo from 'animated-scroll-to';
import PropTypes from 'prop-types';
import exact from 'prop-types-exact';
import Button from '../../common/button/Button';
import ContactForm from '../contact/containers/ContactFormContainer';


class AnuncieConoscoComponent extends Component {
    constructor(props) {
        super(props);

        this.state = {
            buttonsActive: {
                whatsapp: false,
                telComercial: false,
                chatComercial: true,
            },
            imageFile: 'anuncie-header-banner_500x176.jpg', // default image for ssr (extra small size)
            imageWidth: 500,
            imageHeight: 176,
        };

        this.imageBasePath = 'https://a1media.antena1.com.br/image/anuncieConosco/';

        // this.callToActionLink = 'https://publicidade.antena1.com.br/loja?utm_source=Antena%201&utm_medium=anuncie-conosco-page&utm_campaign=anuncie-conosco&utm_content=first-cta-button';

        this.numWhatsapp = '(11) 96622-4502';

        this.numTelComercial = '(11) 3038-8000';

        this.links = {
            whatsapp: 'https://api.whatsapp.com/send?phone=5511966224502',
            telComercial: 'tel:+55-11-3038-8000',
            chatComercial: 'https://publicidade.antena1.com.br?utm_source=Antena%201&utm_medium=anuncie-conosco-page&utm_campaign=anuncie-conosco&utm_content=chat-button', //
        };

        this._handleButtonClick = this._handleButtonClick.bind(this);
    }

    componentDidMount() {
        animateScrollTo(0, { speed: 700 });

        // define image and sizes for the browser
        const isExtraSmall = this.props.breakpoint.isExtraSmall;
        const isSmall = this.props.breakpoint.isSmall;
        const isMedium = this.props.breakpoint.isMedium;
        let imageFile = 'anuncie-header-banner_1140x400.jpg';
        let imageWidth = 1140;
        let imageHeight = 400;

        if (isExtraSmall) {
            imageFile = 'anuncie-header-banner_500x176.jpg';

            imageWidth = 500;

            imageHeight = 176;
        } else if (isSmall) {
            imageFile = 'anuncie-header-banner_700x246.jpg';

            imageWidth = 700;

            imageHeight = 246;
        } else if (isMedium) {
            imageFile = 'anuncie-header-banner_900x316.jpg';

            imageWidth = 900;

            imageHeight = 316;
        }

        this.setState({
            imageFile,
            imageWidth,
            imageHeight,
        });
    }

    _handleButtonClick(key) {
        // if the button is already active, open the corresponding link
        if (this.state.buttonsActive[key]) {
            return window.open(this.links[key]);
        }

        // if it is not active, toggle it active
        return this.setState((prevState) => ({ buttonsActive: {
            ...prevState.buttonsActive,
            [key]: !prevState.buttonsActive.key,
        } }));
    }

    render() {
        const imagePath = this.imageBasePath + this.state.imageFile;

        return (
            <section className="sectionAnuncieConosco">
                <header>
                    <h1>Anuncie conosco</h1>
                    <p className="pageSubtitle">Formatos exclusivos para você anunciar sua marca</p>
                </header>
                <div className="containerAnuncieConosco">
                    <div className="headerImage">
                        <img alt="Mulher ouvindo música e olhando para o celular" src={imagePath} width={this.state.imageWidth} height={this.state.imageHeight} />
                        <div className="headerImageTextContainer">
                            <div className="headerImageText">
                                <p>
                                    Anuncie na maior rede de rádios voltada para o público adulto qualificado do Brasil, Antena 1.
                                </p>
                            </div>
                        </div>
                    </div>
                    <div className="textAnuncieConosco">
                        <h2>Encontrar o público-alvo é um desafio?</h2>
                        <br />
                        Nós resolvemos isso para você!
                        <br />
                        Associamos sua marca à música de qualidade e alcançamos o público certo com o melhor resultado.
                        <br />
                        {/* <br />
                        <div className="listBox">
                            <b>Faça você mesmo a sua publicidade, é muito simples:</b>
                            <ol>
                                <li>Escolha a cidade que deseja veicular;</li>
                                <li>Selecione a quantidade de impactos que planeja alcançar;</li>
                                <li>Envie o arquivo (spot) do seu comercial;</li>
                                <li>Faça o pagamento com cartão de crédito, débito ou boleto.</li>
                            </ol>
                        </div>
                        <br />
                        Após a aprovação do material enviado, é só sintonizar a Antena 1 e ouvir o seu spot na nossa programação. */}
                        {/* eslint-disable-next-line max-len */}
                        Entre em contato com a nossa equipe comercial para saber como a Antena 1 pode te ajudar a encontrar novos clientes com qualquer investimento.
                        <br />
                        Nos envie uma mensagem pelo formulario de contato ou WhatsApp ou ligue para nós. Veja as opções de contato abaixo:
                    </div>
                    {/* <Button className="btnCallToAction" title="Clique aqui e divulgue a sua marca!" href={this.callToActionLink}>
                        Clique aqui e divulgue a sua marca!
                    </Button>
                    <div className="divider">
                        <hr />
                        <span>Ou</span>
                    </div> */}
                    <h2>Envie sua mensagem</h2>
                    <ContactForm subject="comercial" />
                    <div className="divider">
                        <hr />
                        <span>Ou</span>
                    </div>
                    <h2>
                        Fale com um dos nossos executivos
                    </h2>
                    <div className="containerButtons">
                        <div className="buttonContainer">
                            <Button
                                title="WHATSAPP"
                                onClick={() => this._handleButtonClick('whatsapp')}
                            >
                                {this.state.buttonsActive.whatsapp ? this.numWhatsapp : 'WhatsApp Comercial'}
                            </Button>
                            <p className="buttonAlert">
                                {this.state.buttonsActive.whatsapp ? 'Clique novamente para abrir o WhatsApp' : ''}
                            </p>
                        </div>
                        <div className="buttonContainer">
                            <Button
                                title="TELEFONE COMERCIAL"
                                onClick={() => this._handleButtonClick('telComercial')}
                            >
                                {this.state.buttonsActive.telComercial ? this.numTelComercial : 'Telefone Comercial'}
                            </Button>
                            <p className="buttonAlert">
                                {this.state.buttonsActive.telComercial ? 'Clique novamente para fazer a ligação' : ''}
                            </p>
                        </div>
                        <div className="buttonContainer">
                            <Button
                                title="Chat Comercial"
                                onClick={() => this._handleButtonClick('chatComercial')}
                            >
                                Chat Comercial
                            </Button>
                        </div>
                    </div>
                    <div className="containerButtons affiliates">
                        <div className="buttonContainer affiliates">
                            <Button
                                className="affiliates"
                                title="Conheça nossas praças"
                                to="/afiliadas"
                            >
                                Estamos nas principais capitais, conheça nossas praças
                            </Button>
                        </div>
                    </div>
                </div>
            </section>
        );
    }
}

AnuncieConoscoComponent.propTypes = exact({
    breakpoint: PropTypes.object.isRequired,
});

const mapStateToProps = (state) => ({
    breakpoint: state.breakpointReducer,
});

// passing an empty object for mapDispatchToProps to avoid dispatch being passed on and causing prop-types-exact to complain
export default connect(mapStateToProps, {})(AnuncieConoscoComponent);
